// apps/web/src/hooks/useAnalyticsDecidePeerBenchmark.ts
//
// P8a Decide tab — sector vs global activity comparison from leak-site
// claims, last 7 days. Backed by GET
// /api/stories/analytics/decide/peer-benchmark?sectors=…

import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface DecidePeerSector {
  sectorSlug: string
  userCount: number
  globalCount: number
  deltaPct: number
}

export interface DecidePeerBenchmarkResponse {
  globalFallback: boolean
  sectors: DecidePeerSector[]
}

export function useAnalyticsDecidePeerBenchmark(sectors: string[]) {
  const qs = sectors.length
    ? `?sectors=${encodeURIComponent(sectors.join(','))}`
    : ''
  return useQuery<DecidePeerBenchmarkResponse>({
    queryKey: ['analytics', 'decide', 'peer-benchmark', sectors],
    queryFn: () =>
      api.get<DecidePeerBenchmarkResponse>(
        `/stories/analytics/decide/peer-benchmark${qs}`,
      ),
    staleTime: 5 * 60 * 1000,
  })
}
